





















import { defineComponent, Ref, ref } from '@vue/composition-api';

export default defineComponent({
    name: 'input-secret',
    props: {
        title: {
            type: String,
            default: '',
        },
        initValue: {
            type: String,
            default: '0000000000000000000000',
        },
        secret: {
            type: String,
            default: '',
        },
        toggle: {
            type: Function,
            // default: () => {},
        },
    },
    setup(props, context) {
        const inputType: Ref<string> = ref('password');
        async function toggleType() {
            if (inputType.value === 'text') {
                inputType.value = 'password';
                return;
            }
            // @ts-ignore
            const res = props.toggle();
            res.then((value: boolean) => {
                if (value) {
                    inputType.value = 'text';
                }
            });
        }
        return {
            inputType,
            toggleType,
        };
    },
});
